import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { useFetchPlanStateIfNull } from '../util/hooks';
import { useAppStepNavigation } from '../util/hooks/useAppStepNavigation';
import { PlanStatus } from '@payright/types-bnpl-checkout-api';

const resultStatuses = [
  PlanStatus.CANCELLED,
  PlanStatus.CLOSED,
  PlanStatus.DECLINED,
  PlanStatus.ACTIVE,
  PlanStatus.REVIEW,
  PlanStatus.APPROVED_PENDING_ID,
  PlanStatus.APPROVED_STATEMENT_REQUESTED,
];

export const useInitialRedirect = () => {
  const { goToStep, goToErrorPage } = useAppStepNavigation();
  const hasRedirected = useRef(false);

  const checkoutId = useSelector((state: RootState) => state.checkout.checkout?.id);
  useFetchPlanStateIfNull(); // TODO : Make sure we aren't fetching plan if we aren't logged in

  const plan = useSelector((state: RootState) => state.plan.plan);
  const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
  const currentStep = plan?.applicationStep || 'Plan Purpose';

  useEffect(() => {
    // Only perform the redirect once and only if we have a valid plan and user is logged in
    if (hasRedirected.current || !plan || !isLoggedIn) return;

    if (resultStatuses.includes(plan.status)) {
      goToStep('Plan Result');
    } else if (plan.status !== PlanStatus.PENDING && plan.status !== PlanStatus.APPROVED) {
      goToErrorPage('This application cannot be completed');
    } else {
      goToStep(currentStep);
    }
    hasRedirected.current = true;
  }, [checkoutId, currentStep, plan, isLoggedIn]);
};
